/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
export default (function () {});


//////////////////
// WEBPACK FOOTER
// ../nivo/es/lib/noop.js
// module id = 55
// module chunks = 0